/* Slider dots */
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('slider-component');

  sliders.forEach((sliderComponent) => {
    const slider = sliderComponent.querySelector('ul[id^="Slider-"]');
    const dots = sliderComponent.querySelectorAll('.slider-dot');

    if (!slider || !dots.length) return;

    const slides = slider.querySelectorAll('.slider__slide');

    function updateDots() {
      let index = 0;

      slides.forEach((slide, i) => {
        const rect = slide.getBoundingClientRect();

        if (rect.left >= 0 && rect.left < window.innerWidth / 2) {
          index = i;
        }
      });

      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[index]) dots[index].classList.add('active');
    }

    // Click en dots
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = dot.dataset.index;
        const targetSlide = slides[index];

        if (targetSlide) {
          targetSlide.scrollIntoView({
            behavior: 'smooth',
            inline: 'start',
            block: 'nearest'
          });
        }
      });
    });

    slider.addEventListener('scroll', updateDots);
    updateDots();
  });
});